"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Cookie_1 = require("./lib/Cookie");
exports.Cookie = Cookie_1.Cookie;
var CKies_1 = require("./lib/CKies");
exports.ckies = CKies_1.CKies;
exports.CookieOptions = CKies_1.CookieOptions;
exports.CookieType = CKies_1.CookieType;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ckies/library/dist/index.js
// module id = 852
// module chunks = 193 194 199